import Plugin from 'src/plugin-system/plugin.class';
import anime from 'animejs/lib/anime.es.js';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class ImFokusSliderPlugin extends Plugin {

    init() {

        gsap.registerPlugin(ScrollTrigger);

        let tl = gsap.timeline({
            scrollTrigger: {
              trigger: this.el,
              start: "10% 40%",
              end: "bottom 60%",
              scrub: 1,
              markers: false
            },
            onComplete: () => {
                // gsap.to('.im-fokus-slider-widget__kreislauf path, .im-fokus-slider-widget__kreislauf ellipse', {
                //     strokeWidth: '6'
                // });
                gsap.to(".im-fokus-slider-widget__kreislauf", {
                    scale: 1.25,
                    duration: 1,
                    yoyo: true,
                    repeat: 2
                });
            }
        });

        tl.to('.im-fokus-slider-widget__image-above', {
            opacity: 1
        });

        tl.to('.im-fokus-slider-widget__kreislauf', {
            bottom: '14%',
            left: '41.5%',
            width: '13%',
            rotate: 360
        }, '<');

        tl.to('.im-fokus-slider-widget__kreislauf path, .im-fokus-slider-widget__kreislauf ellipse', {
            strokeWidth: '10'
        }, '<');

        this._resizeImage();
        this._registerEvents();
        //this._registerAnimation();
    }

    _registerEvents() {

        var that = this;

        $( window ).on('resize', () => {
            that._resizeImage();
        });

        // if ("IntersectionObserver" in window) {

        //     let kreislaufObserver = new IntersectionObserver((entries, observer) => {
        //         entries.forEach(function(entry) {
        //           if (entry.isIntersecting) {
        //             that._registerAnimation();
        //             kreislaufObserver.unobserve(entry.target);
        //           }
        //         });
        //     });

        //     kreislaufObserver.observe(document.querySelector('.im-fokus-slider-widget__kreislauf'));

        // } else {

        //     window.addEventListener('scroll', function() {
        //         var element = document.querySelector('.im-fokus-slider-widget__kreislauf');
        //         var position = element.getBoundingClientRect();

        //         if(position.top >= 0 && position.bottom <= window.innerHeight) {
        //             that._registerAnimation();
        //         }

        //     });
        // }
    }

    _resizeImage() {

        //$(this.el).find('.im-fokus-slider-widget__slide').height($(this.el).find('.im-fokus-slider-widget__slide .row').height() + 'px');

        var windowWidth = $(window).width();
        var containerWidth = $('.container').width();
        var paddingLeft1 = parseInt($('.im-fokus-slider-widget__slider-wrapper').css('paddingLeft'));
        var paddingLeft2 = parseInt($('.im-fokus-slider-widget__inside').css('paddingLeft'));
        var imagesWrapperWidth = $('.im-fokus-slider-widget__images-wrapper').width();

        //$(this.el).find('.im-fokus-slider-widget__image-wrapper').width(paddingLeft1 + paddingLeft2 + ((windowWidth - containerWidth) / 2) + imagesWrapperWidth + 'px');
        //$(this.el).find('.im-fokus-slider-widget__image-wrapper').width(((windowWidth - containerWidth) / 2) + imagesWrapperWidth + 'px');

        var slideHeight = $(this.el).find('.im-fokus-slider-widget__slide').height();
        var imageHeight = $(this.el).find('.im-fokus-slider-widget__slide .im-fokus-slider-widget__image').height();
        var heightDifference = imageHeight - slideHeight;

        anime.timeline({ loop: false })
            .add({
                targets: '.im-fokus-slider-widget__slider-wrapper',
                paddingTop: heightDifference + 'px',
                easing: "easeInOutQuad",
                duration: 500,
                complete: function(anim) {
                    ScrollTrigger.refresh();
                }
            });

        //$(this.el).find('.im-fokus-slider-widget__slider-wrapper').css('padding-bottom', heightDifference/2 + 'px');
    }

    // _registerAnimation() {

    //     $('.im-fokus-slider-widget__kreislauf').addClass('has--started');
    //     $('.im-fokus-slider-widget__image-above').addClass('is--visible');

    //     anime({
    //         targets: '.im-fokus-slider-widget__circle',
    //         opacity: 1,
    //         duration: 1000,
    //         delay: 4800,
    //         begin: function(anim) {
    //             $('.im-fokus-slider-widget__circle').addClass('is--visible');
    //         }
    //     });
    // }
}
